<template>
  <div>
    <!-- Error flash message -->
    <div class="alert alert-danger" role="alert" v-if="error">
      {{ error.message }}
    </div>

    <div class="alert alert-success" v-if="success">
        {{ success }}
    </div>

    <form class="needs-validation"
      method="POST"
      autocomplete="off"
      @submit.prevent="requestPasswordReset">

      <div class="form-group">
        <label for="username">
          E-mail
        </label>

        <input type="email"
          :class="{ 'form-control': true, 'is-invalid': usernameError }"
          id="username"
          name="username"
          v-model="username"
          placeholder="Insira o email para redefinir sua senha"
          required>

        <span v-if="usernameError" class="invalid-feedback auth-link">
          <strong>
            {{ usernameError }}
          </strong>
        </span>
      </div>

      <button type="submit" :disabled="processing" class="btn btn-primary btn-block btn-flat">
        Redefinir Senha
      </button>

      <div class="form-group text-center auth-link">
        <router-link :to="{ name: 'auth.login' }">
          <small>
            Voltar para o Login
          </small>
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { get } from 'lodash'
  import { decode } from 'he'
  import { requestPasswordReset } from '@/services/auth'

  export default {
    data () {
      return {
        processing: false,

        username: '',
        success: ''
      }
    },

    computed: {
      ...mapGetters({
        error: 'errors/getFirstGlobal',
        fieldError: 'errors/getFirstGlobalError'
      }),

      usernameError () { return this.fieldError('username') }
    },

    methods: {
      ...mapActions({
        pushError: 'errors/pushGlobalError',
        clearError: 'errors/clearGlobalErrors'
      }),

      requestPasswordReset () {
        const self = this

        self.processing = true
        self.clearError()

        requestPasswordReset({ username: self.username })
          .then((res) => {
            self.processing = false
            if (get(res.headers, 'x-message-level') === 'success') {
              self.success = decode(get(res.headers, 'x-message-content'))
            }

            self.username = ''
          })
          .catch((e) => {
            self.processing = false
            if (e.response) {
              self.pushError([e.response.data])
            }
          })
      }
    }
  }
</script>

<style lang="sass" scoped>
  form
    font-weight: normal;
    margin-top: 50px;

    label
      color: #5a6779;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;

    input
      height: 55px;
      border: 1px solid #ccc;

    .btn
      margin: 30px 0px 20px;
      height: 55px;
      font-weight: bold;
      font-size: 14px;
      text-transform: uppercase;

    .auth-link

      small
        font-weight: 600;
        font-size: 12px;
        color: #5a6779;
        transition: 500ms linear;

        &:hover

          color: #000;

      ::placeholder

          color: #A3A3A3;

</style>



// WEBPACK FOOTER //
// src/components/pages/auth/ForgotPassword.vue